import { message } from "antd";
import React, { useEffect } from "react";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import { parseJwt, setProfile, setToken } from "@helpers/utils";

const Callback = () => {
  const history = useHistory();
  const { search } = useLocation();
  const { to } = useParams();

  useEffect(() => {
    const query = new URLSearchParams(search);
    try {
      const token = query.get("Token");
      if (token) {
        const payload = parseJwt(token);
        setProfile({ ...payload, role: "admin" });
        setToken(token);
      }
    } catch (error) {
      message.error("Action has error",20);
      console.log(error);
    }

    setTimeout(() => {
      const toPath = atob(to || btoa("/dashboard/overview"))
      history.push(toPath);
    }, 2000);

    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen w-screen flex justify-center items-center">
      <div className="text-gray-600 font-medium">
        <p>
          If you are not redirected in five seconds,{" "}
          <Link
            to="/dashboard/overview"
            className="text-blue-500 hover:text-blue-700"
          >
            click here
          </Link>
          .
        </p>
      </div>
    </div>
  );
};

export default Callback;
